'use client';

import { useState } from 'react';
import Link from 'next/link';
import styles from '../styles/Docs.module.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Menu from '../components/Menu';

export default function DocsPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <Navbar toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
      <Menu isOpen={isMenuOpen} />
      <div className={styles.docsContainer}>
        <h1>GAM Documentation</h1>
        <p>
          Welcome to the official GAM documentation. Here you&apos;ll find guides and tutorials 
          to help you navigate the GAM ecosystem and make the most of your experience.
        </p>
        
        <div className={styles.docsList}>
          <h2>Guides</h2>
          <ul>
            <li>
              <Link href="/docs/how-to-setup-a-crypto-wallet">
                Getting Started: How to Set Up a Crypto Wallet
              </Link>
            </li>
            <li>
              <Link href="/docs/how-to-purchase-gam-tokens">
                How to Purchase GAM Tokens - A Step-by-Step Guide
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <Footer />
    </>
  );
} 